import axios from "@/utils/axios";
import { STUDENT } from "@/constants/userRoles";
import { reject, isNil } from "ramda";
import { RESET_INVITE, ADD_INVITE_NOTIFICATION, CLEAR_INVITE_NOTIFICATION } from "../constants";

const initialState = () => ({
  inviteNotification: null,
});
const state = initialState();

const actions = {
  clearInviteNotification({ commit }) {
    return commit(CLEAR_INVITE_NOTIFICATION);
  },
  addInviteNotification({ commit }, { organizationName, success } = {}) {
    return commit(ADD_INVITE_NOTIFICATION, {
      organizationName,
      success,
    });
  },
  acceptInvite(context, { token, email }) {
    return axios.post("/v2/accounts/invite/accept", {
      token,
      email,
    });
  },
  inviteUsers(
    context,
    {
      organizationId: organization,
      groupId: group = null,
      role = STUDENT,
      emails = [],
      first_names = [],
      last_names = [],
    } = {}
  ) {
    const payload = reject(isNil)({
      organization,
      group,
      role,
      emails,
      first_names,
      last_names,
      auto_join: 1,
    });

    return axios.post("/v2/accounts/invite/", payload);
  },
  reset({ commit }) {
    return commit(RESET_INVITE);
  },
  getInviteUploadUrl(context, { fileName, fileSize, contentType, organizationId, groupId, role } = {}) {
    const payload = reject(isNil)({
      file_size: fileSize,
      content_type: contentType === "application/vnd.ms-excel" ? "text/csv" : contentType,
      organization: organizationId,
      group: groupId,
      file_name: fileName,
      role,
    });

    return axios.post("/v2/invitations/batch/", payload);
  },
  getInviteUploadEmails(context, { uploadId, params = {} }) {
    const config = Object.keys(params).length > 0 ? { params } : {};
    return axios.get(`/v2/invitations/batch/${uploadId}/`, config);
  },
  updateInviteUploadEmails(context, { uploadId, fileName, fileSize, contentType, organizationId, groupId, role } = {}) {
    const payload = reject(isNil)({
      file_size: fileSize,
      content_type: contentType,
      organization: organizationId,
      group: groupId,
      file_name: fileName,
      role: role,
    });

    return axios.put(`/v2/invitations/batch/${uploadId}/`, payload);
  },
  patchInviteUploadEmails(context, { uploadId, fileName, fileSize, contentType, organizationId, groupId, role } = {}) {
    const payload = reject(isNil)({
      file_size: fileSize,
      content_type: contentType,
      organization: organizationId,
      group: groupId,
      file_name: fileName,
      role: role,
    });

    return axios.patch(`/v1/invitations/batch/${uploadId}/`, payload);
  },
  async postSentInviteUploadEmails(context, { uploadId} = {}) {
    const params = { auto_join: 1 };

    return axios.post(`/v1/invitations/batch/${uploadId}/send/`, {}, { params });
  },
  async postSentInviteUploadElsaUser(context, { uploadId} = {}) {
    const params = { auto_join: 1 };

    return axios.post(`/v1/invitations/batch/${uploadId}/send_elsa_user/`, {}, { params });
  },
  resendInvite(_, inviteId) {
    return axios.post(`/v2/invitations/${inviteId}/resend/`);
  },
  resendMultiInvite(_, { organizationId, inviteIds }) {
    const payload = {
      invitation_ids: inviteIds,
    };
    return axios.post(`/v2/invitations/resend/${organizationId}/`, payload);
  },
  validateTokenInvite(_, { token }) {
    return axios.get(`/v1/invitations/validate/${token}/`);
  },
};

const mutations = {
  [CLEAR_INVITE_NOTIFICATION](state) {
    state.inviteNotification = {};
  },
  [ADD_INVITE_NOTIFICATION](state, payload) {
    state.inviteNotification = {
      ...payload,
    };
  },
  [RESET_INVITE](state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
